import { gql } from '@apollo/client'

export const GET_CATEGORIES = gql`
  query GetCategories($active_only: Boolean!, $with_plugin_count: Boolean) {
      categories (active_only: $active_only, with_plugin_count: $with_plugin_count) {
          id,
          name,
          plugin_count
      }
  }
`
